import { Col, Table, Row } from "reactstrap";
import TableHeader from "../../AkTable/TableHeader";
import TableData from "./TableData";
import TableLoader from "../../AkTable/TableLoader";
import "../../AkTable/table.scss";
import {
  CurrencyExchangeDetailsType,
  TDSDetailsType,
} from "../../../redux/masterData/masterTypes";
import { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  getMasterTdsModuleAction,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  resetTdsModuleList,
  resetTdsSingleData,
} from "../../../redux/masterData";
import { GetTdsMasterPayloadType } from "../../../commonTypes/masterDataTypes";


interface Props {
  data: any | undefined;
  fetching?: boolean;
  type?: string;
  client_code?: any;
  token?: any;
  history?: any;
  count?: number | undefined;
  editEntry: (index: number) => void;
  deleteEntry?: Function;
  // fetchNewData: Function;
  tableHeader: any;
  totalValue?: any;
  setTds?: any;
  tds?: any;
  // loginData?: any;
  currencySign: string | undefined;
  currencyExchangeDetails?: CurrencyExchangeDetailsType | undefined;
  primaryData?: any;
  currencyExchangeError?: string | null;
  clientCurrencyShortForm?: string | undefined;
  clientCurrencyName?: string | undefined;
  dispatchGetTdsModuleAction: (data: GetTdsMasterPayloadType) => void;
  masterFetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  tdsDataList: TDSDetailsType[] | [];
}

const ItemTable: React.FC<Props> = ({
  data = [],
  fetching,
  count,
  editEntry,
  deleteEntry,
  tableHeader,
  dispatchGetTdsModuleAction,
  token,
  tdsDataList,
}) => {

  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [tdsTcsdata, setTdsTcsData] = useState<any[]>([]);

  useEffect(() => {
    if (token) {
      let finalData: GetTdsMasterPayloadType = {
        token,
        limit,
        offset,
      };
      dispatchGetTdsModuleAction(finalData);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tdsDataList?.length === 0) {
      setTdsTcsData(tdsDataList);
    }
    if (offset > 0) {
      setTdsTcsData((prv: any) => [...prv, ...tdsDataList]);
    } else {
      setTdsTcsData(tdsDataList);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tdsDataList]);


  return (
    <>
      {fetching ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      ) : (
        <>
          <Row>
            <Col xs="12">
              <div
                className="table-bordered jobsType sticky-table-header-without-zindex"
                style={{ background: "white" }}
              >
                <Table className="table table-bordered thead-light">
                  <thead className="sticky-table-header text-start">
                    <TableHeader tableHeader={tableHeader} />
                  </thead>
                  <tbody>
                    <TableData
                      data={data}
                      tableHeader={tableHeader}
                      editEntry={editEntry}
                      deleteEntry={deleteEntry}
                    />
                    {/* {renderEmptyBlock()} */}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  masterFetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  tdsDataList: state.masterData.tdsDataList,
  tdsDataTotalCount: state.masterData.totalCount,
  success: state.masterData.success,
  message: state.masterData.message,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetTdsList: () => dispatch(resetTdsModuleList()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetSingleTdsDataAction: () => dispatch(resetTdsSingleData()),
  dispatchGetTdsModuleAction: (data: GetTdsMasterPayloadType) =>
    dispatch(getMasterTdsModuleAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemTable);
